// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_3mhCOW9U1WLTXzrlwftUhv","checkbox-mock":"_371JU1UI1xHsAnMzWV25zw","small":"_2VaruKQKRM0DsrSr7nWktc","disabled":"Mb_L8toSxV7pMmXCyDkRi"};